import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[appIccdFormId]',
})
export class IccdFomrIddDirective {
  // tslint:disable-next-line:no-input-rename
  @Input('appIccdFormId') id!: string;

  constructor(
    public readonly templateRef: TemplateRef<any>,
  ) {
  }
}
